const amt_admin = require('amt_admin').default;
const app = require('angular').module('ww2_analytics.invited_players', [amt_admin]);

const activity_template = require('./activity.html');
const retention_template = require('./retention.html');

app.service('invited_players_api', [
    'jsonrpc',
    function(jsonrpc) {
        const service = jsonrpc.newService('invited_players');
        this.retention = service.createMethod('retention');
    }
]);


app.config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('amt.ww2.invited_players', {
            url: '/invited_players',
            abstract: true,
            template: '<div class="row" ui-view></div>',
            data: {
                priority: 801,
                title: 'Invited Players',
                role: 'invited_players',
            },
            menu: {
                glyphicon: 'stats',
                childs: [
                    {
                        state: 'amt.ww2.invited_players.activity',
                        glyphicon: 'stats',
                    },
                    {
                        state: 'amt.ww2.invited_players.retention',
                        glyphicon: 'stats',
                    },
                ],
            },
        })
        .state('amt.ww2.invited_players.activity', {
            url: '/activity',
            template: activity_template,
            reloadOnSearch: false,
            data: {
                priority: 801,
                title: 'Activity',
                role: 'invited_players',
            },
        })
        .state('amt.ww2.invited_players.retention', {
            url: '/retention',
            template: retention_template,
            reloadOnSearch: false,
            data: {
                priority: 801,
                title: 'Retention',
                role: 'invited_players',
            },
            controller: [
                '$scope',
                'invited_players_api',
                function($scope, invited_players_api) {
                    $scope.get_data_method = invited_players_api.retention;
                },
            ],
        })
    },
]);

export default app.name;
